import React, { HTMLAttributes, ReactElement } from 'react';

import { groups } from './footer.groups.data';
import Link from 'atomic/link/link';
import DsaLink from 'atomic/dsa-link/dsa-link';

const FooterGroups: React.FC<HTMLAttributes<HTMLElement>> = () => (
    <div className="footer__groups">
        {groups.map((group, index): ReactElement => (
            <div key={group.label} className="footer__groups-item">
                <h4 className="footer__groups-item__header">
                    {group.label}
                </h4>
                <ul className="footer__groups-item__list">
                    {group.items.map((groupItem): ReactElement => (
                        <li key={groupItem.label}>
                            <Link
                                href={groupItem.href}
                                title={groupItem.label}
                                className="footer__groups-item__link"
                                dangerouslySetInnerHTML={{ __html: groupItem.label }}
                            />
                        </li>
                    ))}
                    {index === 0 && (
                        <DsaLink className="footer__groups-item__link" url="" />
                    )}
                </ul>
            </div>
        ))}
    </div>
);

export default FooterGroups;
